import AboutPage from "../components/AboutPage";
import Head from "next/head";
import Metatags from "../components/Metatags";
import PropTypes from "prop-types";
import { getAboutPage } from "../core/api/aboutPage";
import { getFooter } from "../core/api/core";
import { getMenu } from "../core/api/menu";

export default function About({ data, menuData, globalData }) {
  const { title } = data.wagtail.aboutPage;

  return (
    <>
      <Head>
        <title>Reskinned | {title}</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.aboutPage.metaTitle}
        metaDescription={data.wagtail.aboutPage.metaDescription}
      />
      <AboutPage
        pageData={data.wagtail.aboutPage}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

About.propTypes = {
  menuData: PropTypes.array.isRequired,
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export async function getStaticProps() {
  const { data } = await getAboutPage();
  const menuData = await getMenu();
  const globalData = await getFooter();

  return {
    props: {
      data,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}
